/* eslint-disable @angular-eslint/component-class-suffix */
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Component, Inject } from '@angular/core';

export interface ConfirmDialogConfig<R = any> {
	title: string,
	description: string,
	confirmResultData: R
}

@Component({
	selector: 'lib-confirm',
	standalone: true,
	imports: [MatDialogModule, MatButtonModule, MatIconModule],
	template: `
	<h2 mat-dialog-title class="pr-0">{{config.title}}

		<button class="float-right" mat-icon-button mat-dialog-close>
			<mat-icon>close</mat-icon>
		</button>
	</h2>

	<mat-dialog-content style="min-width: 30rem;">
		<p>{{config.description}}</p>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-button color="warn" mat-dialog-close>Cancel</button>
		<button mat-stroked-button [mat-dialog-close]="config.confirmResultData">Confirm</button>
	</mat-dialog-actions>
	`,
})
export class ConfirmDialog {
	constructor(@Inject(MAT_DIALOG_DATA) public config: ConfirmDialogConfig) { }
}
